import React, { useState, useEffect } from 'react';
import { FiX } from 'react-icons/fi';

const AddRFIModal = ({ isOpen, onClose, onAdd, token }) => {
  const [boards, setBoards] = useState([]);
  const [formData, setFormData] = useState({
    boardId: '',
    subject: '',
    description: '',
    assignee: '',
    dueDate: '',
    status: 'Open'
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (isOpen) {
      fetchBoards();
    }
  }, [isOpen]);

  const fetchBoards = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/boards`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (response.ok) {
        const data = await response.json();
        setBoards(data.boards || []);
        if (data.boards && data.boards.length > 0) {
          setFormData(prev => ({ ...prev, boardId: data.boards[0].id }));
        }
      }
    } catch (error) {
      console.error('Failed to fetch boards:', error);
    }
  };

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/rfis`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          ...formData,
          dueDate: formData.dueDate ? new Date(formData.dueDate).toISOString() : null
        })
      });

      if (response.ok) {
        const data = await response.json();
        onAdd(data.rfi);
        setFormData({ boardId: boards[0]?.id || '', subject: '', description: '', assignee: '', dueDate: '', status: 'Open' });
        onClose();
      } else {
        const data = await response.json();
        setError(data.detail || 'Failed to create RFI');
      }
    } catch (err) {
      setError('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal">
        <div className="modal-header">
          <h2 className="modal-title">Create New RFI</h2>
          <button className="modal-close" onClick={onClose}>
            <FiX size={20} />
          </button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            <div className="form-group">
              <label className="form-label">Project/Board *</label>
              <select
                className="input"
                value={formData.boardId}
                onChange={(e) => setFormData({ ...formData, boardId: e.target.value })}
                required
                data-testid="rfi-board-select"
              >
                {boards.map(board => (
                  <option key={board.id} value={board.id}>{board.name}</option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label className="form-label">Subject *</label>
              <input
                type="text"
                className="input"
                value={formData.subject}
                onChange={(e) => setFormData({ ...formData, subject: e.target.value })}
                required
                data-testid="rfi-subject-input"
              />
            </div>
            <div className="form-group">
              <label className="form-label">Description *</label>
              <textarea
                className="input"
                rows="4"
                value={formData.description}
                onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                required
                data-testid="rfi-description-input"
              />
            </div>
            <div className="form-group">
              <label className="form-label">Due Date</label>
              <input
                type="date"
                className="input"
                value={formData.dueDate}
                onChange={(e) => setFormData({ ...formData, dueDate: e.target.value })}
              />
            </div>
            {error && <div className="form-error">{error}</div>}
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose} disabled={loading}>
              Cancel
            </button>
            <button type="submit" className="btn btn-primary" disabled={loading} data-testid="submit-rfi">
              {loading ? 'Creating...' : 'Create RFI'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddRFIModal;